import createReactComponent from '../createReactComponent';
export default createReactComponent('circle-minus', 'IconCircleMinus', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M9 12l6 0', key: 'svg-1' }],
]);
